/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Saved_SuccessfullyInputs */



/**
* | output |
* | --- |
* | "Share link saved successfully" |
*
* @param {Team_Share_Saved_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_saved_successfully = /** @type {((inputs?: Team_Share_Saved_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Saved_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lien de partage enregistré avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Link zum Teilen erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condividi il collegamento salvato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ссылка для обмена успешно сохранена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enlace compartido guardado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享链接已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有リンクが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर लिंक सफलतापूर्वक सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O link de compartilhamento foi salvo com sucesso.")
	return /** @type {LocalizedString} */ ("Share link saved successfully")
});